/**
 * Composants VUE
 */
import { Component, Vue } from 'vue-property-decorator';


/**
 * Traductions
 */
import locale from '../locales/SMA.json';

@Component({
    i18n : { messages: locale }
})
export class SMAUtils extends Vue {

    /**
     * Affichage du toaster
     * @param title Titre
     * @param variant Variant
     * @param translationKey Clé traduction texte
     */
    protected showToast(title: string, variant: string, translationKey: string) {
        this.$bvToast.toast(this.$t(translationKey).toString(), {
            title, variant, autoHideDelay: 3000, solid: true, toaster: "b-toaster-top-center"
        });
    }

    /**
     * Affichage de la fenêtre de confirmation
     * @param title Titre
     * @param variant Variant
     * @param translationKey Clé traduction texte
     */
    protected showBoxConfirm(title: string, variant: string, translationKey: string) : Promise<boolean> {
        return this.$bvModal.msgBoxConfirm(this.$t(translationKey).toString(), {
            title: title,
            size: 'sm',
            buttonSize: 'sm',
            okVariant: variant,
            okTitle: this.$t('Yes').toString(),
            cancelTitle: this.$t('No').toString(),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        })
    }
}